"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const util_1 = require("../../util");
const Button = (props) => {
    const { onClick, text, cancel, disabled, children, half, color, className } = props;
    return (react_1.default.createElement("button", { className: (0, util_1.cnx)('button--grid', 'bubble', className, [!!cancel, 'cancel'], [!!half, 'button--grid-half'], [!!color, `button--${color}`, 'button--default']), type: "button", onClick: onClick, disabled: disabled },
        react_1.default.createElement("span", null, children),
        text));
};
exports.Button = Button;
Button.defaultProps = {
    text: undefined,
    color: undefined,
    className: undefined,
    disabled: undefined,
    cancel: undefined,
    half: undefined,
    children: undefined,
};
